import axios from "axios";

// Attaches the CSMS API key (x-api-key) to every request that targets the CMS
// API base URL. Other hosts (e.g. the web API) are left untouched so the key is
// never leaked to unrelated endpoints. Registered once at app startup.
const CMS_BASE = process.env.REACT_APP_CHARGEMILES_CMS_END_POINT;
const CMS_API_KEY = process.env.REACT_APP_CHARGEMILES_CMS_API_KEY;

if (CMS_BASE && CMS_API_KEY) {
  axios.interceptors.request.use((config) => {
    const url = config.url || "";
    if (url.startsWith(CMS_BASE)) {
      config.headers = config.headers || {};
      config.headers["x-api-key"] = CMS_API_KEY;
    }
    return config;
  });
}
